import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';

const BillingCardDetails = () => (
  <>
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Cardholder Name"
          value="John Doe"
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Card Number"
          value="**** **** **** 4242"
          disabled
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Expiry Date"
          value="01/24"
          disabled
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="CVV"
          value="***"
          disabled
        />
      </Grid>
    </Grid>
    <Typography variant="caption" color="text.secondary">
      Card details are not required during your free year. You'll be able to add or update your payment method before your subscription renews.
    </Typography>
  </>
);

export default BillingCardDetails; 